var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("v-autocomplete", {
    staticClass: "custom-v-autocomplete",
    attrs: {
      "data-cy": "project-autocomplete",
      placeholder: _vm.placeholder,
      items: _vm.projectItems,
      "item-value": "id",
      "item-text": "desc",
      "return-object": "",
      clearable: _vm.clearable,
      disabled: _vm.isDisabled,
      dense: "",
      flat: "",
      solo: "",
    },
    on: { change: _vm.onProjectSelected },
    scopedSlots: _vm._u([
      {
        key: "item",
        fn: function ({ item }) {
          return [
            _c("div", { staticClass: "d-flex flex-column mb-1" }, [
              _c(
                "span",
                {
                  class: [
                    "text--base",
                    { "selected-item": _vm.isItemSelected(item) },
                    { "text-body-1-medium": _vm.isItemSelected(item) },
                    { "text-body-1 text--text": !_vm.isItemSelected(item) },
                  ],
                },
                [_vm._v(_vm._s(item.desc))]
              ),
            ]),
          ]
        },
      },
    ]),
    model: {
      value: _vm.selectedItem,
      callback: function ($$v) {
        _vm.selectedItem = $$v
      },
      expression: "selectedItem",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }